/**
 * Utility functions for route handling
 */

/**
 * List of public routes that don't require authentication or API calls
 */
export const PUBLIC_PATHS = [
  '/',
  '/login',
  '/verify-email',
  '/email-verified',
  '/two-factor-auth',
  '/two-factor-setup',
  '/forgot-password',
  '/reset-password'
];

/**
 * Check if the current path is a public route
 * @param pathname - The pathname to check (defaults to current location)
 * @returns boolean indicating if the path is public
 */
export const isPublicRoute = (pathname?: string): boolean => {
  const pathToCheck = pathname || window.location.pathname;
  return PUBLIC_PATHS.some(path => {
    if (path === '/') {
      // Only treat '/' as public if it's exactly '/' (login page)
      // Don't treat '/dashboard' or other routes starting with '/' as public
      return pathToCheck === '/';
    }
    return pathToCheck === path || pathToCheck.startsWith(path);
  });
};

/**
 * Check if API calls should be skipped for the current route
 * @param pathname - The pathname to check (defaults to current location)
 * @returns boolean indicating if API calls should be skipped
 */
export const shouldSkipApiCalls = (pathname?: string): boolean => {
  return isPublicRoute(pathname);
};